import request from './request'
import type { OrderStats } from './technicianslist'

interface SettlementConfig {
  essential_care?: {
    type: string
    value: number
  }
  enhanced_care?: {
    type: string
    value: number
  }
  premium_care?: {
    type: string
    value: number
  }
}

export interface TechnicianDetail {
  id: number
  technician_no: string
  name: string
  avatar: string
  phone_code: string
  phone: string
  mobile: string
  work_role: string
  license_no: string
  sin_type: string
  sin_number: string
  residency_status: string
  address: string
  email: string
  status: number
  status_text: string
  settlement_config: SettlementConfig
  order_stats: OrderStats
  upcoming_service: string | null
  create_time: string
  update_time: string
}

interface DetailResponse {
  code: number
  msg: string
  data: TechnicianDetail
}

export async function getTechnicianDetail(id: string | number): Promise<DetailResponse> {
  return request.post('/api/admin/technician/detail', {
    id,
  }) as Promise<DetailResponse>
}
